import React, { useState, useRef, useEffect } from 'react';
import QRCode from 'react-qr-code';
function FinalLinkQr({ finalLink }) {
  const [copied, setCopied] = useState(false);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(finalLink);
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 2000);
  };
  const qrRef = useRef(null);

  useEffect(() => {
    if (qrRef.current && finalLink) {
      qrRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [finalLink]);
  return (
    <div>
      <h6 className="mt-3">Click on the link to copy</h6>
      <div className="p-2 container final-link" data-toggle="tooltip" data-placement="top" title="Click to copy the link" onClick={copyToClipboard} ref={qrRef}>    
        {!copied && finalLink}
        {copied && <span className='link-copied'>COPIED</span>}
      </div>
      <QRCode className="mt-3 mb-3 align-center m-auto w-100"
          value={finalLink}
      />
    </div>
  );
}
export default FinalLinkQr;